export interface Volume {
  number: string;
  title: string;
  description: string;
  cover: string;
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Budowa atomu i układ okresowy',
    description:
      'Atom, pierwiastki, cząstki subatomowe, konfiguracje i układ okresowy przedstawione krok po kroku.',
    cover:
      'https://cdn.magicpatterns.com/uploads/6KMvRMQ4a42DYjjhMQtgwt/chemia-wizualna-tom-01-budowa-atomu-i-uklad-okresowy.webp',
  },
  {
    number: '02',
    title: 'Wiązania chemiczne i hybrydyzacja',
    description:
      'Wiązania, struktury i modele pomagające uczniom zrozumieć, jak i dlaczego atomy łączą się ze sobą.',
    cover:
      'https://cdn.magicpatterns.com/uploads/5rkYouGzH2rtZZkKe4tXYg/chemia-wizualna-tom-02-wiazania-chemiczne-i-hybrydyzacja.webp',
  },
  {
    number: '03',
    title: 'Reakcje chemiczne',
    description:
      'Rozpoznawanie, zapisywanie i analizowanie reakcji chemicznych w jasnej, uporządkowanej formie.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7eyMw8uYfcELXwe3AdUHUS/chemia-wizualna-tom-03-reakcje-chemiczne.webp',
  },
  {
    number: '04',
    title: 'Roztwory i stężenia',
    description:
      'Roztwory, obliczenia i stężenia przedstawione w sposób wizualny, praktyczny i możliwy do przećwiczenia.',
    cover:
      'https://cdn.magicpatterns.com/uploads/vmAwgfahhtXKP99wjWizHp/chemia-wizualna-tom-04-roztwory-i-stezenia.webp',
  },
  {
    number: '05',
    title: 'Kwasy, zasady i pH',
    description: 'pH, pOH, wskaźniki, bufory i miareczkowanie z przykładami, obliczeniami i zadaniami.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7EKDB7icQteSr8USpXd36b/chemia-wizualna-tom-05-kwasy-zasady-i-ph.webp',
  },
  {
    number: '06',
    title: 'Chemia organiczna',
    description:
      'Podstawy chemii organicznej uporządkowane tak, aby uczniowie mogli zobaczyć związki, zależności i zastosowania.',
    cover:
      'https://cdn.magicpatterns.com/uploads/8L5Hv2wT4sdjVP5kXzWE1y/chemia-wizualna-tom-06-chemia-organiczna.webp',
  },
  {
    number: '07',
    title: 'Doświadczenia laboratoryjne i projekty',
    description:
      'Gotowe inspiracje do doświadczeń, pracy praktycznej i projektów, które ożywiają lekcje chemii.',
    cover:
      'https://cdn.magicpatterns.com/uploads/2vN6nvLeUHB9jErPCP2X8A/chemia-wizualna-tom-07-doswiadczenia-i-projekty-laboratoryjne.webp',
  },
];

export interface Bonus {
  badge: string;
  title: string;
  description: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    title: '30 tygodni planów lekcji',
    description:
      'Pomaga uporządkować pracę w ciągu roku i szybciej przygotować kolejne zajęcia.',
  },
  {
    badge: 'BONUS 2',
    title: 'Bank ewaluacji i sprawdzianów',
    description:
      'Gotowe narzędzia do sprawdzania postępów uczniów bez tworzenia każdej oceny od zera.',
  },
  {
    badge: 'BONUS 3',
    title: 'Klucz odpowiedzi i przewodnik metodyczny',
    description:
      'Ułatwia sprawdzanie prac oraz prowadzenie lekcji z większą pewnością i spójnością.',
  },
];

/**
 * Wyłącznie zweryfikowane, autoryzowane opinie.
 * Dopóki tablica jest pusta, sekcja pokazuje zastosowania materiałów — bez fikcyjnych cytatów i ocen.
 */
export interface Testimonial {
  verified: boolean;
  quote: string;
  name: string;
  city: string;
  role: string;
  rating?: number;
}

export const testimonials: Testimonial[] = [];

export interface UsageCard {
  title: string;
  description: string;
}

export const usageCards: UsageCard[] = [
  {
    title: 'Wyjaśniaj',
    description: 'Wizualne strony pomagają wprowadzać trudne pojęcia krok po kroku.',
  },
  {
    title: 'Ćwicz',
    description: 'Gotowe zadania pozwalają uczniom pracować samodzielnie, w parach lub grupach.',
  },
  {
    title: 'Sprawdzaj',
    description: 'Sprawdziany, klucze i materiały wspierają powtórkę oraz ocenę postępów.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'Co dokładnie otrzymam?',
    answer:
      'Otrzymasz dostęp cyfrowy do 7 tomów Wizualnej Chemii™ oraz 3 bonusów dla nauczyciela.',
  },
  {
    question: 'Czy to produkt fizyczny?',
    answer: 'Nie. To zestaw materiałów cyfrowych, które możesz pobrać i wydrukować.',
  },
  {
    question: 'Kiedy otrzymam materiały?',
    answer: 'Dostęp cyfrowy otrzymasz zaraz po zakończeniu zakupu.',
  },
  {
    question: 'Czy to abonament?',
    answer: 'Nie. Płacisz jednorazowo 17 USD. Nie ma miesięcznej subskrypcji.',
  },
  {
    question: 'Dla jakich klas przeznaczone są materiały?',
    answer:
      'Materiały zostały przygotowane z myślą o nauczycielach chemii klas 7–8, liceum i technikum.',
  },
  {
    question: 'Czy klucze odpowiedzi są w zestawie?',
    answer: 'Tak. Klucz odpowiedzi i przewodnik metodyczny są zawarte w Bonusie 3.',
  },
  {
    question: 'Czy mogę używać materiałów z własnymi uczniami?',
    answer:
      'Tak. Materiały są przeznaczone do pracy nauczyciela z własnymi uczniami. Nie wolno ich odsprzedawać ani udostępniać jako własnych materiałów.',
  },
];

export interface GalleryImage {
  src: string;
  alt: string;
}

export const galleryImages: GalleryImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wqBXAZTRUysx5Fa8uCXpiH/01-wiazania-struktura-lewisa.webp',
    alt: 'Struktura Lewisa krok po kroku',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1tQSYvp1BBVkwezSUJYFDe/02-wiazania-trzy-typy-wiazan.webp',
    alt: 'Porównanie trzech typów wiązań chemicznych',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aX3tcxCxhYZbLoHmU26GsS/03-reakcje-strategie-balansowania.webp',
    alt: 'Strategie balansowania równań chemicznych',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pQen9bbwU9PgQg3yVgfVxe/04-reakcje-metoda-mostow-jednostkowych.webp',
    alt: 'Metoda mostów jednostkowych w stechiometrii',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/h8nr9KrsEa5Z6j6DahPtCq/05-laboratorium-wulkan-chemiczny.webp',
    alt: 'Eksperyment: wulkan chemiczny',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/h8VNhwyMo7VB6LPGUfUdDe/06-laboratorium-chemiluminescencja.webp',
    alt: 'Eksperyment: chemiluminescencja',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bR3DfNPfX8NSVevTibdryf/07-laboratorium-projekt-ph-codzienny.webp',
    alt: 'Projekt: pH roztworów codziennych',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/urhQW2V8BbqrXwVfp9WC45/08-bonus-plan-roczny-30-tygodni.webp',
    alt: 'Bonus: roczny rozkład materiału na 30 tygodni',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tjuvUTRKkmxmWiNpvCkKCe/09-bonus-bank-175-pytan.webp',
    alt: 'Bonus: bank ponad 175 pytań',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4RjoS5Rxwb7fZFB2aG1zAv/10-bonus-klucz-odpowiedzi-atom.webp',
    alt: 'Bonus: przykład klucza odpowiedzi',
  },
];
